import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  /** Plain text. Rendered with interpolation, so any markup in it shows as literal characters. */
  message: string;
  /**
   * Optional value rendered in bold straight after {@link message}, for callers that used to
   * wrap part of the sentence in <b> tags. Still plain text: only the emphasis is markup.
   */
  emphasis?: string;
  /** Rest of the sentence, rendered after {@link emphasis}. */
  messageSuffix?: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
  hideCancelButton?: boolean;
}

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrl: "./confirm-dialog.component.scss",
  standalone: false,
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
